module.exports = __webpack_public_path__ + "img/close.2102e903.png";